import type {RefObject} from 'react';
import {useEffect} from 'react';

const useBackgroundClick = (backgroundRef: RefObject<HTMLElement | null>, callback: VoidFunction, active: boolean): void => {
  useEffect(() => {
    if (!active) {
      return;
    }

    const handleClick = (event: MouseEvent): void => {
      if (!event.target) {
        return;
      }

      if (backgroundRef.current && !backgroundRef.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClick);

    return (): void => {
      document.removeEventListener('mousedown', handleClick); // Cleanup on unmount
    };
  }, [callback, active]);
};

export default useBackgroundClick;
